import React from "react";

// Real 210 CodeLabs assets (gold on transparent), used exactly as provided.
const ICON = "/brand/codelabs_icon.png";         // 3D gold hexagon "210" mark
const WORDMARK = "/brand/codelabs_wordmark.png"; // "210 CODELABS" + tagline

// Full lockup (hexagon icon + wordmark) or icon only.
//  `height` = pixel height of the icon; the wordmark scales proportionally beside it.
export const CodeLabsLogo = ({ height = 22, iconOnly = false, className = "" }) => (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <img
      src={ICON}
      alt="210 CodeLabs"
      draggable={false}
      className="block object-contain select-none shrink-0"
      style={{ height, width: "auto" }}
    />
    {!iconOnly && (
      <img
        src={WORDMARK}
        alt="210 CodeLabs"
        draggable={false}
        className="block object-contain select-none shrink-0"
        style={{ height: Math.round(height * 0.62), width: "auto" }}
      />
    )}
  </span>
);

// "DEVELOPED BY" credit — label stacked ABOVE the lockup so it never clips narrow columns.
export const DevelopedBy = ({ labelColor = "#64748B", height = 24, className = "" }) => (
  <div className={`flex flex-col gap-1.5 ${className}`}>
    <span
      style={{
        color: labelColor,
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: "0.22em",
        whiteSpace: "nowrap",
      }}
    >
      DEVELOPED BY
    </span>
    <CodeLabsLogo height={height} />
  </div>
);
